import React from "react";
import { Tooltip } from "@mui/material";

/**
 * Existing uploaded document chip — matches invoice overlay PDF icon theme.
 * Place in the Col beside the file TextField (uses empty row space).
 */
const ExistingDocLink = ({ href, label = "View existing document" }) => {
  if (!href) return null;

  return (
    <div
      className="d-flex align-items-center h-100"
      style={{ minHeight: 40 }}
    >
      <Tooltip title={label} arrow>
        <a
          href={href}
          target="_blank"
          rel="noreferrer"
          className="d-inline-flex align-items-center gap-2 text-decoration-none"
          style={{
            height: 40,
            padding: "0 12px",
            border: "1px solid #c4c4c4",
            borderRadius: 4,
            color: "#28326f",
            background: "#fff",
          }}
        >
          <i className="icon-picture_as_pdf fs-18px text-danger-100" />
          <span className="fs-14px fw-500">{label}</span>
        </a>
      </Tooltip>
    </div>
  );
};

export default ExistingDocLink;
